
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateNotify} from './ConfigUpdateNotify';
import {FieldModelConfigUpdateNotify} from './ConfigUpdateNotify';
import {UpdateType} from '../core/UpdateType';
import {FieldModelUpdateType} from '../core/UpdateType';
import {TradingRouteRule} from '../core/TradingRouteRule';
import {FieldModelTradingRouteRule} from '../core/TradingRouteRule';

/**
 * TradingRouteRuleUpdateNotify struct
 */
class TradingRouteRuleUpdateNotify extends ConfigUpdateNotify {
  /**
   * Initialize struct
   * @param {!ConfigUpdateNotify=} parent
   * @param {!UpdateType=} updateType
   * @param {TradingRouteRule=} previous
   * @param {TradingRouteRule=} current
   * @constructor
   */
  constructor (parent = new ConfigUpdateNotify(), updateType = new UpdateType(), previous = null, current = null) {
    super()
    super.copy(parent)
    this.UpdateType = updateType
    this.Previous = previous
    this.Current = current
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradingRouteRuleUpdateNotify}
   * @param {!TradingRouteRuleUpdateNotify} other Other struct
   * @returns {!TradingRouteRuleUpdateNotify} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.UpdateType != null) {
      this.UpdateType = UpdateType.fromObject(other.UpdateType)
    } else {
      this.UpdateType = null
    }
    if (other.Previous != null) {
      this.Previous = TradingRouteRule.fromObject(other.Previous)
    } else {
      this.Previous = null
    }
    if (other.Current != null) {
      this.Current = TradingRouteRule.fromObject(other.Current)
    } else {
      this.Current = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradingRouteRuleUpdateNotify}
   * @returns {!TradingRouteRuleUpdateNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradingRouteRuleUpdateNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradingRouteRuleUpdateNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradingRouteRuleUpdateNotify}
   * @param {!TradingRouteRuleUpdateNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingRouteRuleUpdateNotify)) {
      throw new TypeError('Instance of TradingRouteRuleUpdateNotify is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradingRouteRuleUpdateNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      UpdateType: ((this.UpdateType != null) ? this.UpdateType : null),
      Previous: ((this.Previous != null) ? this.Previous : null),
      Current: ((this.Current != null) ? this.Current : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradingRouteRuleUpdateNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradingRouteRuleUpdateNotify} other Object value
   * @returns {!TradingRouteRuleUpdateNotify} Created struct
   */
  static fromObject (other) {
    return new TradingRouteRuleUpdateNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradingRouteRuleUpdateNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradingRouteRuleUpdateNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradingRouteRuleUpdateNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6314
  }
}

export { TradingRouteRuleUpdateNotify };

/**
 * Fast Binary Encoding TradingRouteRuleUpdateNotify field model
 */
class FieldModelTradingRouteRuleUpdateNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateNotify(buffer, 4 + 4)
    this.UpdateType = new FieldModelUpdateType(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Previous = new fbe.FieldModelOptional(new FieldModelTradingRouteRule(buffer, this.UpdateType.fbeOffset + this.UpdateType.fbeSize), buffer, this.UpdateType.fbeOffset + this.UpdateType.fbeSize)
    this.Current = new fbe.FieldModelOptional(new FieldModelTradingRouteRule(buffer, this.Previous.fbeOffset + this.Previous.fbeSize), buffer, this.Previous.fbeOffset + this.Previous.fbeSize)
  }

  /**
   * Get the ConfigUpdateNotify field model
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!FieldModelConfigUpdateNotify} ConfigUpdateNotify field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.UpdateType.fbeSize + this.Previous.fbeSize + this.Current.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.UpdateType.fbeExtra + this.Previous.fbeExtra + this.Current.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradingRouteRuleUpdateNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6314
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.UpdateType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.UpdateType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.UpdateType.fbeSize

    if ((fbeCurrentSize + this.Previous.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Previous.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Previous.fbeSize

    if ((fbeCurrentSize + this.Current.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Current.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Current.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!TradingRouteRuleUpdateNotify} fbeValue Default value, defaults is new TradingRouteRuleUpdateNotify()
   * @returns {!TradingRouteRuleUpdateNotify} TradingRouteRuleUpdateNotify value
   */
  get (fbeValue = new TradingRouteRuleUpdateNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!TradingRouteRuleUpdateNotify} fbeValue TradingRouteRuleUpdateNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.UpdateType.fbeSize) <= fbeStructSize) {
      fbeValue.UpdateType = this.UpdateType.get()
    } else {
      fbeValue.UpdateType = new UpdateType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.UpdateType.fbeSize

    if ((fbeCurrentSize + this.Previous.fbeSize) <= fbeStructSize) {
      fbeValue.Previous = this.Previous.get()
    } else {
      fbeValue.Previous = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Previous.fbeSize

    if ((fbeCurrentSize + this.Current.fbeSize) <= fbeStructSize) {
      fbeValue.Current = this.Current.get()
    } else {
      fbeValue.Current = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Current.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {!TradingRouteRuleUpdateNotify} fbeValue TradingRouteRuleUpdateNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradingRouteRuleUpdateNotify}
   * @param {TradingRouteRuleUpdateNotify} fbeValue TradingRouteRuleUpdateNotify value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.UpdateType.set(fbeValue.UpdateType)
    this.Previous.set(fbeValue.Previous)
    this.Current.set(fbeValue.Current)
  }
}

export { FieldModelTradingRouteRuleUpdateNotify };

/**
 * Fast Binary Encoding TradingRouteRuleUpdateNotify model
 */
class TradingRouteRuleUpdateNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradingRouteRuleUpdateNotify(this.buffer, 4)
  }

  /**
   * Get the TradingRouteRuleUpdateNotify model
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @returns {!FieldModelTradingRouteRuleUpdateNotify} model TradingRouteRuleUpdateNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradingRouteRuleUpdateNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradingRouteRuleUpdateNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @param {!TradingRouteRuleUpdateNotify} value TradingRouteRuleUpdateNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @param {!TradingRouteRuleUpdateNotify} value TradingRouteRuleUpdateNotify value, defaults is new TradingRouteRuleUpdateNotify()
   * @return {!object} Deserialized TradingRouteRuleUpdateNotify value and its size
   */
  deserialize (value = new TradingRouteRuleUpdateNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradingRouteRuleUpdateNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradingRouteRuleUpdateNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradingRouteRuleUpdateNotifyModel}
   * @param {!number} prev Previous TradingRouteRuleUpdateNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradingRouteRuleUpdateNotifyModel };
